import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import {
  currencyrateAddPath,
  CurrencyrateAddUrlQueryParams,
  currencyrateListPath,
  CurrencyrateListUrlQueryParams,
  CurrencyrateListUrlSortField,
  currencyratePath,
  CurrencyrateUrlQueryParams
} from "./urls";
import CurrencyrateCreateComponent from "./views/CurrencyrateCreate";
import CurrencyrateDetailsComponent from "./views/CurrencyrateDetails";
import CurrencyrateListComponent from "./views/CurrencyrateList";

const CurrencyrateList: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: CurrencyrateListUrlQueryParams = asSortParams(
    qs,
    CurrencyrateListUrlSortField
  );
  return <CurrencyrateListComponent params={params} />;
};

const CurrencyrateCreate: React.FC<RouteComponentProps<{}>> = ({
  location
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: CurrencyrateAddUrlQueryParams = qs;
  return <CurrencyrateCreateComponent params={params} />;
};

const CurrencyrateDetails: React.FC<RouteComponentProps<{ id: string }>> = ({
  location,
  match
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: CurrencyrateUrlQueryParams = qs;
  return (
    <CurrencyrateDetailsComponent
      id={decodeURIComponent(match.params.id)}
      params={params}
    />
  );
};

export const CurrencyrateSection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.currencyrates)} />
      <Switch>
        <Route exact path={currencyrateListPath} component={CurrencyrateList} />
        <Route
          exact
          path={currencyrateAddPath}
          component={CurrencyrateCreate}
        />
        <Route path={currencyratePath(":id")} component={CurrencyrateDetails} />
      </Switch>
    </>
  );
};

export default CurrencyrateSection;
